module.exports = __webpack_public_path__ + "img/efficiency.e0ad6af5.jpg";